// Canonical domain configuration
// Apex domain is the single source of truth for all canonical URLs,
// OpenGraph, Twitter cards, and JSON-LD structured data.
// This ensures www, preview, and any other host all resolve to the same canonical.
export const CANONICAL_BASE_URL =
  process.env.REACT_APP_CANONICAL_BASE_URL || 'https://brightsonaccounting.co.uk';
